module.exports = __webpack_public_path__ + "static/sc_17-4002383fed16bc1b9a59fcf68b874af1.jpg";